/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Building_Deletion_WarningInputs */



/**
* | output |
* | --- |
* | "All floors, rooms, gateways and thermostatic heads associated with this building will also be deleted" |
*
* @param {Building_Deletion_WarningInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const building_deletion_warning = /** @type {((inputs?: Building_Deletion_WarningInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Building_Deletion_WarningInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("All floors, rooms, gateways and thermostatic heads associated\nwith this building will also be deleted")
	return /** @type {LocalizedString} */ ("Tous les niveaux, pièces, box et têtes thermostiques associés\nà ce bâtiment seront supprimés également")
});